module.exports = __webpack_public_path__ + "img/thailand.5fe3b1db.png";